import { Card, Stack, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import { ReactNode, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Inventory from '../../../../../../api/db/Inventory'
import pubsub from '../../../../../../modules/pubsub'
import { IInventoryMeta } from '../../../../../../shared/types'
import { selectCurrrentAdminShop } from '../../../../../../store/features/currentBusinessShop'
import { selectUserPropsState } from '../../../../../../store/features/user'
import { BalanceScaleIcon, NotAllowedIcon, PackageIcon } from '../../../../../atoms/icons'
import HeaderSkeleton from '../../../../common/skeletons/HeaderSkeleton'

export default function ContentHeader() {

    const [loading, setLoading] = useState(true)
    const [meta_data, setMetaData] = useState<IInventoryMeta|null>(null)
    const user_id = useSelector(selectUserPropsState)?.uid
    const current_shop = useSelector(selectCurrrentAdminShop)?.name
    
    useEffect(()=>{

        pubsub.on("inventory:changed", getMetadata)
        getMetadata()

    // eslint-disable-next-line
    },[])

    const getMetadata = async ()=>{

        try {

            setLoading(true)
            const res = await Inventory.getMetaData(user_id!, current_shop!)
            setMetaData(res)
            setLoading(false)
            
        } catch (error) {
            setLoading(false)
            console.log(error);
        }
        
    }
    
    return (
        <>
            {
                (loading || meta_data === null) ? (
                    <HeaderSkeleton />
                ):(
                    <Stack direction="row" spacing={2} >

                        <InfoCard 
                            Icon={<PackageIcon />}
                            title={"Total Items (In Grams)"}
                            subTitle={meta_data?.inventory_size.toString() ?? ""}

                        />

                        <InfoCard 
                            Icon={<BalanceScaleIcon />}
                            title={"Expected Income"}
                            subTitle={`GH₵ ${meta_data?.expected_revenue}`}
                        />

                        <InfoCard 
                            Icon={<NotAllowedIcon />}
                            title={"Total Items (In Cartons)"}
                            subTitle={meta_data?.expired.toString() ?? 0}
                        />


                    </Stack>
                )
            }
        </>
    )
}



const styles = {

    cardMin:{
        flex: 1, 
        // height: 150, 
        borderRadius: "4px", 
        backgroundColor: 'primary.main',
        // backgroundColor: 'primary.dark',
        border: `.5px solid rgba(255, 255, 255, 0.1)`,
        padding: "1rem"
    },

}


const InfoCard = ({Icon, subTitle, title}:{Icon: ReactNode, subTitle:string, title:string})=>{

    return(
        <Card variant="outlined" sx={styles.cardMin}>

            <Stack direction="column" sx={{height: "100%"}}  justifyContent="space-between">

                <Stack direction="row" spacing={2} >
                    <div
                        style={{
                            width: "18%",
                            // height: "50px",
                            padding: "0.5rem",
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            borderRadius: "3px"
                        }}
                    >
                        {Icon}
                    </div>

                    <Typography textAlign="left" >
                        <Typography color={grey[500]}>{title}</Typography>
                        <Typography variant="h6" >{subTitle}</Typography>
                    </Typography>

                </Stack>

                <div className='opacity-0 mt-10' />

            </Stack>
        </Card>
    )
    
}